import { RichText } from "components/slices/RichText";
import { SMALL } from "shared/variables";
import { StarRating } from "components/StarRating";
import styles from "./ReviewCard.module.css";

export const ReviewCard = ({ name, createdAt, rating, message }) => {
  const d = new Date(createdAt);
  const date = `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <StarRating rating={rating} />
        <div>
          {name}
          {createdAt && ` • ${date}`}
        </div>
      </div>

      <RichText size={SMALL}>{message}</RichText>
    </div>
  );
};
